// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import App from './App';
import router from './router';

import 'font-awesome/css/font-awesome.css';

Vue.config.productionTip = false;

function initVue() {
    new Vue({
        el: '#app',
        router,
        template: '<App/>',
        components: { App }
    });
}

// TODO: Move this in a shared lib (It should actually already be)
let Url = {
    getValueParam(url, key, defaultValue) {
        let regex = new RegExp('[?&#]' + key.replace(/[[\]]/g, '\\$&') + '(=([^&#]*)|&|#|$)');
        let results = regex.exec(url);

        if (results && results.length > 1 && results[2]) {
            return decodeURIComponent(results[2].replace(/\+/g, ''));
        }

        return defaultValue;
    }
};

Vue.use(VueI18n);
Vue.config.lang = Url.getValueParam(window.location.href, 'lang', window.navigator.language);
Vue.config.fallbackLang = 'en-US';

let retrieveLocale = (locale) => {
    return new Promise((resolve, reject) => {
        let request = new XMLHttpRequest();

        request.onreadystatechange = function() {
            if (this.readyState !== 4) {
                return;
            }

            if (this.status === 200) {
                Vue.locale(locale, { str: JSON.parse(this.responseText) });
                resolve();
            } else {
                console.log('Unable to retrieve the locale: ' + locale);
                reject();
            }
        };

        request.open('GET', 'locales/' + locale + '.json', true);
        request.send();
    });
};

retrieveLocale(Vue.config.lang).then(initVue).catch(() => {
    if (Vue.config.fallbackLang === Vue.config.lang) {
        initVue();
    } else {
        retrieveLocale(Vue.config.fallbackLang).then(initVue).catch(initVue);
    }
});



// WEBPACK FOOTER //
// ./src/main.js